import { render } from "./SettingsFormModal.vue?vue&type=template&id=5bf28b26&ts=true"
import script from "./SettingsFormModal.vue?vue&type=script&lang=ts"
export * from "./SettingsFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__